import User from '@/models/Users/User'
import _ from 'lodash'

import router from '@/routes'
import store from '@/store'

import {ActiveTableConfig} from '@/components/Ui/ActiveTable/BZCore/ActiveTable'
import {TableOptions} from '@/components/Ui/ActiveForm/BZCore/Table/Table'

import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'

import IndexColumn from '@/components/Users/UserTable/cols/indexColumn.vue'
import DetailRow from '@/components/Users/UserTable/cols/detailRow.vue'

import Status from '@/components/Users/UserTable/cols/status.vue'
import Messengers from '@/components/Users/UserTable/cols/messengers.vue'

// @ts-ignore
import messages from '@/lang/index';

const StudentsActiveTableConfig: ActiveTableConfig<User> = {
  documentsName: messages.labels.employees1,
  indexColumnComponent: IndexColumn,
  defaultPageSize: 10,
  onRowClick ({rowIndex, toggleRowDetail}) {
    toggleRowDetail(rowIndex);
  },
  async find (search, filters, sortKeys, limit, offset) {
    let emptyKeys: string[] = [];
    for (let key in filters) {
      if (Array.isArray(filters[key]) && !filters[key].length) {
        emptyKeys.push(key)
        continue;
      }
      if (filters[key] === '') {
        emptyKeys.push(key)
      }
    }
    for (let key of emptyKeys) {
      delete filters[key]
    }

    let sort: string[][] = []
    if (Object.keys(sortKeys).length) {
      for (const key in sortKeys) {
        sort.push([key, sortKeys[key]])
      }
    }

    if (!Object.keys(filters).length) {
      return {
        count: 0,
        list: []
      }
    };

    const params = {
      ...filters,
      limit,
      offset,
      sort
    }
    const result = await store.dispatch('users/findUsers', params)
    console.log('LOG: find -> result', result)
    return {
      count: result.count,
      list: result.users
    }
  },
  async loadFiltersValues () {
  },
  filtersAndActions: {
    pageName: messages.labels.search_and_filters,
    searchFormButtonText: messages.labels.search_employees,
    searchForm: {
      inputs: {
        last_name: {
          type: StringField,
          label: messages.labels.cols.last_name
        },
        first_name: {
          type: StringField,
          label: messages.labels.cols.first_name
        },
        middle_name: {
          type: StringField,
          label: messages.labels.cols.middle_name
        },
        email: {
          type: StringField,
          label: messages.labels.email
        },
        phone: {
          type: StringField,
          label: messages.labels.phone
        },
        login: {
          type: StringField,
          label: messages.labels.login
        },
      },
      steps: [
        {map: [['last_name', 'first_name', 'middle_name', 'email', 'phone', 'login']]}
      ]
    },
    filters: {}
  },
  defaultShownColumns: ['last_name', 'first_name', 'middle_name', 'status', 'messengers'],
  table: {
    cols: {
      last_name: {label: messages.labels.cols.last_name, sortable: true},
      first_name: {label: messages.labels.cols.first_name, sortable: true},
      middle_name: {label: messages.labels.cols.middle_name, sortable: true},
      status: {label: messages.labels.cols.status, component: Status, sortable: true},
      messengers: {label: messages.labels.cols.messengers, component: Messengers}
    },
    detailRowComponent: DetailRow
  } as TableOptions
}
export default StudentsActiveTableConfig